import React from "react";
import { Dimmer, Icon } from "semantic-ui-react";

const SFLoader = (props) => {
  return (
    <Dimmer active={props.active} inverted verticalAlign="top">
      <div style={{ marginTop: "500px" }}>
        <div>
          <Icon loading name="circle notched" size="huge" color="grey" />
        </div>
        <div style={{ marginTop: "10px" }}>
          {props.message ? props.message : "Loading"}
        </div>
      </div>
    </Dimmer>
  );
};

export default SFLoader;
